import { Injectable } from '@angular/core';
import { CookieKeys, CookieParams } from '@core/const';
import { SsrCookieService as NgxCookieService } from 'ngx-cookie-service-ssr';

@Injectable({ providedIn: 'root' })
export class CookieService {
  constructor(private ngxCookieService: NgxCookieService) {}

  get(key: CookieKeys): string {
    return this.ngxCookieService.get(key);
  }

  put(key: CookieKeys, value: string, params: CookieParams = {}): void {
    this.ngxCookieService.set(key, value, params.expires, params.path, params.domain, params.secure, params.sameSite);
  }

  hasKey(key: CookieKeys): boolean {
    return this.ngxCookieService.check(key);
  }

  remove(key: CookieKeys, params: CookieParams = {}): void {
    this.ngxCookieService.delete(key, params.path, params.domain, params.secure, params.sameSite);
  }

  isAutomationTest(): boolean {
    return this.get(CookieKeys.AutomationTest) === '1';
  }
}
